/**
 * Shared `?page=` sanitizer for the blog listing routes.
 *
 * TanStack Start runs `validateSearch` for the client, but on the server the
 * RAW search object also reaches `loaderDeps` — so `?page=abc` used to flow
 * straight into the posts query as `offset: NaN`, fail oRPC's zod input
 * validation, and 500 the page. Using ONE sanitizer in BOTH `validateSearch`
 * and `loaderDeps` guarantees the loader only ever sees a positive integer.
 */

/** Coerce any raw `page` value to a positive integer (defaults to 1). */
export function sanitizePage(raw: unknown): number {
  const n = Math.floor(Number(raw));
  return Number.isFinite(n) && n >= 1 ? n : 1;
}

/**
 * `validateSearch` for paginated listings. Page 1 carries no `?page` param so
 * the canonical listing URL stays clean.
 */
export function pageSearch(search: Record<string, unknown>): {
  page?: number;
} {
  const page = sanitizePage(search.page);
  return page > 1 ? { page } : {};
}

/** `loaderDeps` for paginated listings — always a sanitized page number. */
export function pageDeps({ search }: { search: Record<string, unknown> }): {
  page: number;
} {
  return { page: sanitizePage(search.page) };
}
